<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserInfoStore } from "../../stores/userInfo";
import { globalStore } from "../../stores/global";
import Clase from "../EyClause.vue";

const global = globalStore();
const router = useRouter();
const userInfo = useUserInfoStore();

const showClase = ref(false);

const goLink = (myRouterlink: string) => {
  clearSearchValueFun();
  if (userInfo.token) {
    router.push(myRouterlink);
  } else {
    router.replace({
      path: "/login",
      query: {
        redirect: myRouterlink,
      },
    });
  }
};

const clearSearchValueFun = () => {
  global.clearSearchValue();
};

const menuActive = ref<string>("");

onMounted(() => {
  // // 监听菜单变化
  router.beforeEach((to, from, next) => {
    let newValue = to.fullPath;
    if (newValue.indexOf("/policyCollection") != -1) {
      menuActive.value = "policyCollection";
    } else if (newValue.indexOf("/browseRecords") != -1) {
      menuActive.value = "browseRecords";
    } else if (newValue.indexOf("/contactUs") != -1) {
      menuActive.value = "contactUs";
    } else if (newValue.indexOf("/aboutUs") != -1) {
      menuActive.value = "aboutUs";
    } else {
      menuActive.value = "";
    }
    next();
  });
});
</script>

<template>
  <div class="footer-component">
    <div class="container-box">
      <div class="copyright-box">
        <span>政策通平台-上海市老年基金会 版权所有©</span>
        <span>沪ICP备15041765号-5</span>
        <span>沪公网安备 31011502016149号</span>
      </div>
      <ul class="menu-box">
        <li>
          <a @click.stop="showClase = true"> 隐私政策 </a>
        </li>
        <li class="line"></li>
        <li :class="{ disabled: !userInfo.token }">
          <a
            @click="goLink('/policyCollection')"
            :class="{ active: menuActive == 'policyCollection' }"
          >
            我的收藏
            <div class="login-tip" v-if="!userInfo.token">需登录</div>
          </a>
        </li>
        <li class="line"></li>
        <li :class="{ disabled: !userInfo.token }">
          <a
            @click="goLink('/browseRecords')"
            :class="{ active: menuActive == 'browseRecords' }"
          >
            浏览记录
            <div class="login-tip" v-if="!userInfo.token">需登录</div>
          </a>
        </li>
        <li class="line"></li>
        <li>
          <router-link
            to="/aboutUs"
            @click="clearSearchValueFun"
            :class="{ active: menuActive == 'aboutUs' }"
            >关于我们</router-link
          >
        </li>
      </ul>
    </div>
    <Clase v-model:isShowClausePopup="showClase" />
  </div>
</template>

<style scoped lang="less">
.footer-component {
  width: 100%;
  height: 55px;
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  .container-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .copyright-box {
      width: 50%;
      // max-width: 620px;
      display: flex;
      justify-content: inherit;
      span {
        font-size: 14px;
        margin-right: 10px;
        color: #999999;
      }
    }
    .menu-box {
      display: flex;
      justify-content: inherit;
      align-items: center;
      padding: 0;
      margin: 0;
      width: 50%;
      max-width: 500px;
      li {
        position: relative;
        &.line {
          width: 1px;
          height: 13px;
          background: #e5e5e5;
        }
        &:last-child {
          padding-right: 0;
          &::after {
            display: none;
          }
        }
        a {
          font-size: 18px;
          cursor: pointer;
          position: relative;
          display: block;
          &:hover {
            .login-tip {
              display: block;
            }
          }
          .login-tip {
            display: none;
            font-size: 12px;
            padding: 3px;
            border-radius: 3px;
            background-color: #eeeeee;
            position: absolute;
            right: -45px;
            top: -15px;
            &:after {
              content: "";
              width: 6px;
              height: 5px;
              background: url("@/assets/images/login_tip_pointer.png") no-repeat
                center center;
              position: absolute;
              left: 0;
              bottom: -5px;
            }
          }
        }

        .active {
          color: #ffe600;
          &::after {
            content: "";
            width: 50%;
            height: 1px;
            background: #ffe600;
            position: absolute;
            left: 50%;
            margin-left: -25%;
            bottom: -5px;
          }
        }
        &.disabled a {
          color: #999999;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .footer-component {
    padding: 20px 0;
    height: auto;
    .container-box {
      display: block;
      .copyright-box {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        display: block;
        span {
          margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .menu-box {
        width: 100%;
        margin: 0 auto;
        display: none;
        li {
          position: relative;
          a {
            font-size: 16px;
            .login-tip {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
